import axios from '@/utils/request'
var Qs = require('qs')

export default {
    //2020-11-03
    findByWorkerOrderId(workOrderId) {
        return axios.get('/mes/qas/find-by-work-order-id/' + workOrderId);
    },
    //2020-12-24
    insertBatch(params) {
        return axios.post('/mes/qas/insert-batch', params);
    },
    //2021-02-23
    qaReport(params) {
        return axios.get('/mes/qas/qa-report?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
    },
    //2021-02-23
    exportExcelQaReport(params) {
        return axios.get('/mes/qas/export-excel-qa-report?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
    }
}
